"use client"

import { useRouter, useSearchParams } from "next/navigation"

export enum Filter {
  Technologies = "Technologies",
  Features = "Features",
  OtherFilters = "Other filters",
}
export function useSearch() {
  const router = useRouter()
  const searchParams = useSearchParams()
  const filterState = searchParams.get("filter") ?? null
  const featuresState = searchParams.get("features") ?? null
  const technosState = searchParams.get("technos") ?? null
  const minPriceState = searchParams.get("minPrice") ?? null
  const maxPriceState = searchParams.get("maxPrice") ?? null
  const searchNameState = searchParams.get("search") ?? null
  const tab = searchParams.get("tab") ?? "all-time"

  function search({
    technos,
    features,
    minPrice,
    maxPrice,
    filter,
    searchName,
    tab,
  }: {
    technos?: string[] | null
    features?: string[] | null
    minPrice?: number | null
    maxPrice?: number | null
    filter?: string | null
    searchName?: string | null
    tab?: "all-time" | "this-week" | null
  }) {
    let filterURL = ""
    if (filter !== undefined) {
      if (filter !== null) {
        filterURL = `?filter=${filter}`
      } else {
        filterURL = "?filter=none"
      }
    } else if (filterState) {
      filterURL = `?filter=${filterState}`
    } else {
      filterURL = "?filter=none"
    }

    let featuresURL = ""
    if (features !== undefined) {
      if (features !== null && features.length > 0) {
        featuresURL += `&features=${features.join(",")}`
      }
    } else if (featuresState) {
      featuresURL += `&features=${featuresState}`
    }

    let technosURL = ""
    if (technos !== undefined) {
      if (technos !== null && technos.length > 0) {
        technosURL = `&technos=${technos.join(",")}`
      }
    } else if (technosState) {
      technosURL = `&technos=${technosState}`
    }

    let minPriceURL = ""
    if (minPrice !== undefined) {
      if (minPrice !== null) {
        minPriceURL = `&minPrice=${minPrice}`
      }
    } else if (minPriceState) {
      minPriceURL = `&minPrice=${minPriceState}`
    }

    let maxPriceURL = ""
    if (maxPrice !== undefined) {
      if (maxPrice !== null) {
        maxPriceURL = `&maxPrice=${maxPrice}`
      }
    } else if (maxPriceState) {
      maxPriceURL = `&maxPrice=${maxPriceState}`
    }

    let searchNameURL = ""
    if (searchName !== undefined) {
      if (searchName !== null) {
        searchNameURL = `&search=${searchName}`
      }
    } else if (searchNameState) {
      searchNameURL = `&search=${searchNameState}`
    }

    let tabURL = ""
    if (tab !== undefined) {
      if (tab !== null) {
        tabURL = `&tab=${tab}`
      }
    } else if (tab) {
      tabURL = `&tab=${tab}`
    }

    router.push(
      `/boilerplates${filterURL}${featuresURL}${technosURL}${minPriceURL}${maxPriceURL}${searchNameURL}${tabURL}`
    )
  }

  function reset() {
    window.location.href = "/boilerplates"
  }

  return {
    search,
    filter: filterState,
    features: featuresState,
    technos: technosState,
    minPrice: minPriceState,
    maxPrice: maxPriceState,
    searchName: searchNameState,
    reset,
    tab,
  }
}
